/**
 * Gli occhi che guardano quando non c'è niente da guardare.
 *
 * **In linea e non `<img src="/eyes.svg">`**: un'immagine caricata da fuori è
 * una scatola chiusa per il CSS, e i suoi colori restano quelli del file. Qui
 * i tracciati prendono `currentColor`, quindi basta `text-brand` sul
 * contenitore e il disegno segue l'accento del tema come tutto il resto.
 *
 * L'alone attorno agli occhi resta un filtro **dentro l'SVG**, non una
 * `drop-shadow` CSS. Provata e scartata: il filtro SVG misura la sfocatura in
 * unità del disegno, quindi si rimpicciolisce insieme a lui, mentre la
 * `drop-shadow` CSS la misura in pixel dello schermo. Con il disegno ridotto a
 * un quarto della sua scala nativa le due cose divergono, e l'alone si diluisce
 * fino a sparire — che è appunto quel che era successo.
 *
 * Quello che è cambiato è solo il COLORE. Prima stava cotto dentro una matrice
 * (`feColorMatrix` con 0 / 0.905882 / 0.87451: il ciano di marca scritto a mano
 * in un formato dove nessuno lo avrebbe cercato). Ora è `flood-color="currentColor"`,
 * quindi l'alone è lo stesso colore degli occhi e segue l'accento con loro.
 *
 * `feDropShadow` al posto della catena originale di cinque primitive
 * (`feColorMatrix` → `feOffset` → `feGaussianBlur` → `feComposite` → `feBlend`):
 * fa esattamente la stessa cosa in un'istruzione, con gli stessi parametri.
 */
export function EyesArt({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 321 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <defs>
        {/* La regione del filtro va allargata a mano: quella predefinita è il
            riquadro della forma più il 10%, e un alone sfocato di 17 unità ne
            uscirebbe tagliato di netto su tutti i lati. */}
        <filter
          id="eyes-glow"
          x="-50%"
          y="-50%"
          width="200%"
          height="200%"
          filterUnits="objectBoundingBox"
        >
          <feDropShadow
            dx="0.545455"
            dy="0.727273"
            stdDeviation="16.8727"
            floodColor="currentColor"
            floodOpacity="1"
          />
        </filter>
      </defs>

      <g filter="url(#eyes-glow)">
        <path
          d="M110.654 61.5373L33.1992 33.0182C36.1926 39.8978 45.547 55.2331 59.0174 61.5373C72.4878 67.8415 99.0543 64.1641 110.654 61.5373Z"
          fill="currentColor"
        />
        <path
          d="M208.288 61.5373L285.742 33.0182C282.749 39.8978 273.394 55.2331 259.924 61.5373C246.454 67.8415 219.887 64.1641 208.288 61.5373Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}
